
import Vue from 'vue';
import { transformLink } from '~/transforms/transformComponents';

export default Vue.extend({
  props: {
    singleItem: { type: Boolean, default: true },
    locationDetails: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      links: Array(),
    };
  },

  computed: {
    linkElement() {
      return this.locationDetails.links.map((linkItem: any) => {
        const linkObject = transformLink(linkItem.link, linkItem.label);
        if (linkObject && linkObject.url.includes('ro/ro-ro')) {
          return { ...linkObject, url: '/ro-ro/' };
        }
        return linkObject;
      });
    },
  },
});
